<!-- <h2 mat-dialog-title>Dialog Title</h2> -->

<mat-dialog-content>
    <info-card *ngIf="item" [(item)]="item" [expand]="true" [expandable]="true">
    </info-card>
</mat-dialog-content>

<mat-dialog-actions fxLayout="column" fxLayoutAlign="end end">
    <button mat-button color="primary" mat-dialog-close>
        Close
    </button>
</mat-dialog-actions>